import React, {Component, Fragment} from "react";
import {withRouter} from "react-router-dom";
import "./Register.css";
import {Col, Input, Row} from "reactstrap";
import DropdownComponent from "../../components/DropdownComponent";
import S3DocumentUploadComponent from "../../components/S3DocumentUploadComponent";
import RegistrationService from "../../services/Registration/RegistrationService";
import RegistrationDocumentsService from "../../services/Registration/RegistrationDocumentService";
import FileUtil from "../../domain/Util/FileUtil";
import ToastHelper from "../../utils/ToastHelper";
import UtilityService from "../../services/UtilityService";
import RegistrationCreationRequest from "../../domain/Registration/RegistrationCreationRequest";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import DatePickerComponent from "../../components/DatePickerComponent";
import * as QueryStringUtils from "../../utils/QueryStringUtils";
import SFXLoadingComponent from "../../components/SFXLoadingComponent";
import UserSessionService from "../../services/UserSessionService";
import AgentPrivilege from "../../enum/AgentPrivilege";
import UnsupportedBrowserComponent from "../../components/UnsupportedBrowserComponent";
import { isMobile, isTablet } from "react-device-detect";
import { getUser } from "../../services/UserSessionService"




const GENDERS = [
    {id: "MALE", name: "Male"},
    {id: "FEMALE", name: "Female"}
];

const ID_TYPES = [
    {id: "SA_ID", name: "SA ID"},
    {id: "ASYLUM_PAPER", name: "Asylum Paper"},
    {id: "FOREIGN_PASSPORT", name: "Foreign Passport"},
    {id: "FOREIGN_ID", name: "Foreign ID"}
];

const CARD_OPTIONS = [
    {id: 1, name: "Yes"},
    {id: 2, name: "No"}
];

const TITLES = [
    {id: "MISS", name: "Miss"},
    {id: "MR", name: "Mr"},
    {id: "MRS", name: "Mrs"},
    {id: "DR", name: "Dr"},
    {id: "PROF", name: "Prof"},
    {id: "REV", name: "Rev"},
    {id: "SIR", name: "Sir"},
    {id: "THE_HONORABLE_MINISTER", name: "The Honourable Minister"},
    {id: "MASTER", name: "Master"},
    {id: "HIS_EMINENCE", name: "His Eminence"},
    {id: "DAME", name: "Dame"},
    {id: "LADY", name: "Lady"},
    {id: "LORD", name: "Lord"},
    {id: "ESTATE_LATE", name: "Estate Late"},
];

const ETHNICITY = [
    {id: "AFRICAN", name: "African"},
    {id: "COLOURED", name: "Coloured"},
    {id: "INDIAN", name: "Indian"},
    {id: "WHITE", name: "White"},
    {id: "OTHER", name: "Other"},
];

const SOURCE_OF_FUNDS = [
    {id: "SALARY", name: "Salary"},
    {id: "DIVIDEND_INTEREST", name: "Dividend/Interest"},
    {id: "COMMISSIONS", name: "Commissions"},
    {id: "BONUSES", name: "Bonuses"},
    {id: "PENSION", name: "Pension"},
    {id: "RENTAL_INCOME", name: "Rental Income"},
    {id: "LOAN", name: "Loan"},
    {id: "DONATIONS", name: "Donations"},
    {id: "ALIMONY", name: "Alimony"},
    {id: "CHILD_SUPPORT", name: "Child Support"},
    {id: "UNKNOWN", name: "Unknown"},
    {id: "NONE", name: "None"},
];

const CARD_DETAILS_CONFIG = ["cardRequested"];
const CONTACT_DETAILS_CONFIG = ["phoneNumber", "email"];
const DOCUMENTS_CONFIG = ["idType"];
const ID_DETAILS_CONFIG = ["idType", "idNumber", "idExpiryDate", "idIssueDate", "country"];
const ID_DETAILS_SA_CONFIG = ["idType", "idNumber", "idIssueDate", "country"];
const PERSONAL_DETAILS_CONFIG = ["firstName", "lastName", "title", "ethnicity", "sourceOfFunds"];
const SECONDARY_PERSONAL_DETAILS_CONFIG = ["gender", "DOB"];
const ADDRESS_DETAILS_CONFIG = ["streetNumber", "streetName", "town", "city", "province", "postalCode"];
const SECONDARY_ADDRESS_DETAILS_CONFIG = ["staysInComplex", "complexName", "unit"];
const SECONDARY_ADDRESS_DETAILS_NO_COMPLEX_CONFIG = ["staysInComplex"];

const BUTTON_HEADERS = {
    "Identity": {"buttonHeader": "Photo of the Customer's Identity Document", "buttonText": "Document"},
    "Picture": {"buttonHeader": "Photo of the Customer holding their Identity Document", "buttonText": "Selfie"},
    "Permit": {"buttonHeader": "Photo of the Customer's Permit", "buttonText": "Permit"},
    "IdentityBack": {"buttonHeader": "Photo of the back of the Customer's Identity Document", "buttonText": "Document"}
};

const CARD_DETAILS = "card details";
const CONTACT_DETAILS = "contact details";
const IDENTITY_DOCUMENT_DETAILS = "first document details";
const PICTURE_DOCUMENT_DETAILS = "second document details";
const PERMIT_DOCUMENT_DETAILS = "third document details";
const PERSONAL_DETAILS = "personal details";
const SECONDARY_PERSONAL_DETAILS = "Secondary personal details";
const ADDRESS_DETAILS = "address details";
const SECONDARY_ADDRESS_DETAILS = "Secondary address details";
const ID_DETAILS = "nationality details";
const ID_DETAILS_SA = "nationality details_sa";
const REGISTRATION_SUMMARY = "registration summary";

const SA_ID = "SA ID";
const FOREIGN_PASSPORT = "Foreign Passport"
const FOREIGN_ID = "Foreign ID"

const NEXT_BUTTON_TEXT = "Next";
const BACK_BUTTON_TEXT = "Back";
const CONFIRM_BUTTON_TEXT = "Confirm";

class Register extends Component {

    constructor(props) {
        super(props);

        this.registrationHeaders = UserSessionService.retrieveRegisteringHeaders();
        this.props.changeHeader("New Registration");
        this.referralCode = QueryStringUtils.getQueryStringValue("referral-code");

        this.agentCanViewRegistrationCardQuestion = UserSessionService.hasPrivilege(AgentPrivilege.AGENT_PORTAL_REGISTRATION_CARD_QUESTION_VIEW);

        this.state = {
            countryOptions: [],
            provinceOptions: [],
            currentTab: this.agentCanViewRegistrationCardQuestion ? CARD_DETAILS : CONTACT_DETAILS,
            firstName: "",
            lastName: "",
            gender: {"id": 0, "name": ""},
            DOB: '',
            showDate: false,
            phoneNumber: "",
            email: "",

            cardRequested: {id: 2, name: "No"},
            title: {"id": 0, "name": ""},
            ethnicity: {"id": 0, "name": ""},
            idIssueDate: '',
            unit: "",
            complexName: "",
            sourceOfFunds: {"id": 0, "name": ""},
            staysInComplex: {"id": 0, "name": ""},

            idType: {"id": 0, "name": ""},
            idNumber: "",
            idExpiryDate: '',
            country: {"id": "", "name": ""},

            streetNumber: "",
            streetName: "",
            town: "",
            city: "",
            province: {"id": 0, "name": ""},
            postalCode: "",

            touchedFields: {},
            inValidFields: {},
            validFields: {},

            requiredDocuments: [],
            selectedDocuments: [],
            uploadedDocuments: {},
            file: null,

            submitButtonClicked: false,
            referralCode: this.referralCode,
            loading: true,
            loadingMessage: "",

            hasSmartIdCard: false
        };

        this.schema = RegistrationCreationRequest.retrieveNewRegistrationValidationConfig();

        this.handleChange = this.handleChange.bind(this);
        this.dropdownChange = this.dropdownChange.bind(this);
        this.hasBeenTouched = this.hasBeenTouched.bind(this);
        this.doneSelectingDocument = this.doneSelectingDocument.bind(this);
        this.doneUploadingDocument = this.doneUploadingDocument.bind(this);
        this.showNextDetailsPage = this.showNextDetailsPage.bind(this);
        this.goBack = this.goBack.bind(this);
        this.handleUpload = this.handleUpload.bind(this);
        this.createNewRegistration = this.createNewRegistration.bind(this);
        this.renderContent = this.renderContent.bind(this);
        this.renderCardDetails = this.renderCardDetails.bind(this);
        this.renderContactDetails = this.renderContactDetails.bind(this);
        this.renderIdentityDocumentDetails = this.renderIdentityDocumentDetails.bind(this);
        this.renderPictureDocumentDetails = this.renderPictureDocumentDetails.bind(this);
        this.renderPermitDocumentDetails = this.renderPermitDocumentDetails.bind(this);
        this.renderNationalityDetails = this.renderNationalityDetails.bind(this);
        this.renderPersonalDetails = this.renderPersonalDetails.bind(this);
        this.renderSecondaryPersonalDetails = this.renderSecondaryPersonalDetails.bind(this);
        this.renderAddressDetails = this.renderAddressDetails.bind(this);
        this.renderSecondaryAddressDetails = this.renderSecondaryAddressDetails.bind(this);
        this.renderSummary = this.renderSummary.bind(this);
        this.renderButton = this.renderButton.bind(this);
        this.renderInput = this.renderInput.bind(this);
        this.renderDropdown = this.renderDropdown.bind(this);
        this.addDocumentToRequiredDocumentList = this.addDocumentToRequiredDocumentList.bind(this);
    }

    componentDidMount() {

        let promiseArr = [];

        promiseArr.push(UtilityService.retrieveCountryList());
        promiseArr.push(UtilityService.retrieveProvinceList());
        promiseArr.push(RegistrationDocumentsService.retrieveRegistrationRequiredDocuments());

        Promise.all(promiseArr).then(response => {

            let countryList = response[0];
            let provinceList = response[1];
            let requiredDocumentsList = response[2];

            this.setState({
                countryOptions: countryList,
                provinceOptions: provinceList,
                requiredDocuments: requiredDocumentsList.map(function (item) {
                    return item.documentType
                }),
                loading: false
            })
        })
    }

    showNextDetailsPage(nextPage) {
        this.setState({
            currentTab: nextPage
        })
    }

    goBack() {

        if (this.state.currentTab === CARD_DETAILS) {
            this.props.history.replace("/home");
        } else if (this.state.currentTab === CONTACT_DETAILS) {
            if (this.agentCanViewRegistrationCardQuestion) {
                this.setState({
                    currentTab: CARD_DETAILS
                })
            } else {
                this.props.history.replace("/home");
            }

        } else if (this.state.currentTab === IDENTITY_DOCUMENT_DETAILS) {
            this.setState({
                currentTab: CONTACT_DETAILS
            })
        } else if (this.state.currentTab === PICTURE_DOCUMENT_DETAILS) {
            this.setState({
                currentTab: IDENTITY_DOCUMENT_DETAILS
            })
        } else if (this.state.currentTab === PERMIT_DOCUMENT_DETAILS) {
            this.setState({
                currentTab: PICTURE_DOCUMENT_DETAILS
            })
        } else if (this.state.currentTab === ID_DETAILS) {
            this.setState({
                currentTab: this.state.idType.name === FOREIGN_PASSPORT && this.state.cardRequested.name === "Yes" ? PERMIT_DOCUMENT_DETAILS : PICTURE_DOCUMENT_DETAILS
            })
        } else if (this.state.currentTab === ID_DETAILS_SA) {
            this.setState({
                currentTab: this.state.idType.name === FOREIGN_PASSPORT && this.state.cardRequested.name === "Yes" ? PERMIT_DOCUMENT_DETAILS : PICTURE_DOCUMENT_DETAILS
            })
        } else if (this.state.currentTab === SECONDARY_PERSONAL_DETAILS) {
            this.setState({
                currentTab: this.state.idType.name !== SA_ID && this.state.idType.name !== FOREIGN_ID ? ID_DETAILS : ID_DETAILS_SA
            })
        } else if (this.state.currentTab === PERSONAL_DETAILS) {
            this.setState({
                currentTab: SECONDARY_PERSONAL_DETAILS
            })
        } else if (this.state.currentTab === ADDRESS_DETAILS) {
            this.setState({
                currentTab: PERSONAL_DETAILS
            })
        } else if (this.state.currentTab === SECONDARY_ADDRESS_DETAILS) {
            this.setState({
                currentTab: ADDRESS_DETAILS
            })
        } else if (this.state.currentTab === REGISTRATION_SUMMARY) {
            this.props.history.replace("/home");
        }
    }

    handleChange = (event, field) => {

        this.setState({
            [event.target.id]: event.target.value
        }, () => {

            if (field === "idNumber") {
                if (this.state.idType.name === SA_ID) {
                    this.setState({
                        gender: this.extractGenderFromID(this.state.idNumber),
                        DOB: this.extractDOBFromID(this.state.idNumber)
                    });
                } else {
                    this.setState({
                        gender: {"id": 0, "name": ""},
                        DOB: ''
                    });
                }
            }

            this.validateInputField(field)
        });
    };

    handleDateChange(field, value) {

        this.setState({
            [field]: value
        }, () => this.validateInputField(field))
    }

    dropdownChange = (event, field) => {

        let newEvent;
        if (event === null) {
            if (field === 'country') {
                newEvent = {"id": "", "name": ""}
            } else {
                newEvent = {"id": 0, "name": ""}
            }
        } else {
            newEvent = {...event};
        }

        this.setState({
            [field]: {
                id: newEvent.id,
                name: newEvent.name
            }
        }, () => this.validateInputField(field));
    };

    handleUpload() {
        let self = this;

        Object.keys(this.state.selectedDocuments).forEach(selectedDocument => {

            let documentType = selectedDocument;

            let file = this.state.selectedDocuments[selectedDocument];

            let fileType = FileUtil.getExtensionOfFile(file.fileUpload.name);
            let mimeType = FileUtil.getMimeType(fileType);

            let s3Document = {
                "file-type": fileType,
                "registration-document-type": documentType
            };

            RegistrationDocumentsService.retrievePresignedUrl(s3Document).then(response => {
                if (response.presignedUrl === undefined) {
                    ToastHelper.error("Failed to retrieve upload url.");
                    return;
                }

                const xhr = new XMLHttpRequest();
                xhr.open('PUT', response.presignedUrl);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            let uploadedDocument = {...self.state.uploadedDocuments};
                            uploadedDocument[documentType] = response;
                            self.setState({
                                uploadedDocuments: uploadedDocument
                            }, () => self.doneUploadingDocument());
                        } else {
                            ToastHelper.error("Error while uploading image.");
                        }
                    }
                };
                xhr.overrideMimeType(mimeType);
                xhr.setRequestHeader('Content-Type', mimeType);
                xhr.send(file.fileUpload);
            });
        });
    }

    doneUploadingDocument() {

        let allUploaded = true;
        this.state.requiredDocuments.forEach(requiredDocument => {
            if (this.state.uploadedDocuments[requiredDocument] === undefined) {
                allUploaded = false;
            }
        });
        if (allUploaded) {
            this.createNewRegistration();
        } else {
            this.setState({
                loading: false
            })
        }
    }

    doneSelectingDocument(documentType) {
        let allSelected = true;
        if (this.state.selectedDocuments[documentType] === undefined) {
            allSelected = false;
        }

        return allSelected;
    }

    createNewRegistration() {

        if (this.submitting) {
            return;
        }

        this.submitting = true;

        let documents = [];

        for (let i = 0; i < this.state.requiredDocuments.length; i++) {

            let documentType = this.state.requiredDocuments[i];

            documents.push({
                "meta-data-id": this.state.uploadedDocuments[documentType].id,
                "document-type": documentType
            })
        }

        let registrationCreationRequest = {
            "city": this.state.city,
            "dob": this.state.DOB,
            "documents": documents,
            "firstName": this.state.firstName,
            "gender": this.state.gender.id,
            "idType": this.state.idType.name,
            "idNumber": this.state.idNumber,
            "lastName": this.state.lastName,
            "msisdn": this.state.phoneNumber,
            "postalCode": this.state.postalCode,
            "streetNumber": this.state.streetNumber,
            "streetName": this.state.streetName,
            "town": this.state.town,
            "province": this.state.province.name,
            "email": this.state.email,
            "cardRequested": this.state.cardRequested.name === "Yes" ? true : false,
            "title": this.state.title.id,
            "ethnicity": this.state.ethnicity.id,
            "idIssueDate": this.state.idIssueDate,
            "unit": this.state.unit,
            "complexName": this.state.complexName,
            "sourceOfFunds": this.state.sourceOfFunds.id
        };

        if (registrationCreationRequest.idType === SA_ID || registrationCreationRequest.idType === FOREIGN_ID) {
            registrationCreationRequest["idExpiryDate"] = "9999-12-31";
            registrationCreationRequest["nationality"] = this.state.country.id;

        } else {
            registrationCreationRequest["idExpiryDate"] = this.state.idExpiryDate;
            registrationCreationRequest["nationality"] = this.state.country.id;
        }

        RegistrationService.createRegistration(registrationCreationRequest, this.state.referralCode).then(response => {
            if (response.registrationId) {
                this.setState({
                    currentTab: REGISTRATION_SUMMARY,
                    loading: false
                });
            } else {
                this.submitting = false;
                this.setState({
                    loading: false,
                    submitButtonClicked: false
                });
                ToastHelper.formatError(response)
            }
        })
    }

    invalidateIdNumber() {
        let previousValidState = {...this.state.validFields};
        delete previousValidState["idNumber"];
        this.setState({
            idNumber: "",
            validFields: previousValidState
        });
    }

    extractGenderFromID(fieldValue) {
        let genderCode = parseInt(fieldValue.substring(6, 10), 10);
        return genderCode > 4999 ? GENDERS[0] : GENDERS[1];
    }

    extractDOBFromID(fieldValue) {
        let year = 1900 + parseInt(fieldValue.substring(0, 2), 10);
        let currentYear = new Date().getFullYear();
        if (currentYear - year > 100)
            year += 100;
        let month = fieldValue.substring(2, 4);
        let day = fieldValue.substring(4, 6);

        return year + '-' + month + '-' + day;
    }

    validateInputField(field) {
        let self = this;
        let previousInvalidValidations = {...this.state.inValidFields};
        delete previousInvalidValidations[field];
        let previousValidValidations = {...this.state.validFields};
        previousValidValidations[field] = true;

        this.setState({
            inValidFields: previousInvalidValidations,
            validFields: previousValidValidations
        }, () => {

            let fieldValue = this.state[field].id === undefined ? this.state[field] : this.state[field].name;

            if (field === "idType" && fieldValue === SA_ID) {
                delete this.schema["idNumber"];
                this.schema["idNumber"] = RegistrationCreationRequest.retrieveSAIDValidationConfig()
                this.invalidateIdNumber();
            } else if (field === "idType" && fieldValue !== SA_ID) {
                delete this.schema["idNumber"];
                this.schema["idNumber"] = RegistrationCreationRequest.retrieveNonSAIDValidationConfig();
                this.invalidateIdNumber();
            } else if (field === "country" && this.state["idType"].name !== SA_ID) {
                this.schema["country"] = RegistrationCreationRequest.retrieveCountryValidationConfig();
            } else if (field === "email" && this.state["cardRequested"].name === "Yes") {
                delete this.schema["email"];
                this.schema["email"] = RegistrationCreationRequest.retrieveEmailRequiredValidationConfig(true);
            } else if (field === "cardRequested" && fieldValue === "No") {
                delete this.schema["email"];
                this.schema["email"] = RegistrationCreationRequest.retrieveEmailRequiredValidationConfig(false);
                this.hasBeenTouched("email");
            } else if (field === "cardRequested" && fieldValue === "Yes" && this.state.phoneNumber !== "") {
                this.hasBeenTouched("email");
            }

            if (this.schema[field] !== undefined) {
                this.schema[field].validate({[field]: fieldValue}).catch(function (err) {

                    let previousInvalidValidations = {...self.state.inValidFields};
                    previousInvalidValidations[field] = err.message;
                    let previousValidValidations = {...self.state.validFields};
                    delete previousValidValidations[field];
                    self.setState({
                        inValidFields: previousInvalidValidations,
                        validFields: previousValidValidations
                    });
                })
            }
        })
    }

    hasBeenTouched(field) {

        let previousTouched = {...this.state.touchedFields};
        previousTouched[field] = true;
        this.setState({
                touchedFields: previousTouched
            }, () => this.validateInputField(field)
        )
    }

    isNextButtonValid(config) {
        let allFieldsComplete = true;

        config.forEach(field => {
            if (field === "email" && this.state.email === "" && this.state.cardRequested.name === "No") return;
            if (field === "idIssueDate" && this.state.cardRequested.name === "No") return;
            if (field === "title" && this.state.cardRequested.name === "No") return;
            if (field === "ethnicity" && this.state.cardRequested.name === "No") return;
            if (field === "sourceOfFunds" && this.state.cardRequested.name === "No") return;
            if (field === "complexName" && this.state.cardRequested.name === "No") return;
            if (this.state.validFields[field] === undefined) {
                allFieldsComplete = false;
            }
        });

        if (this.state.currentTab === IDENTITY_DOCUMENT_DETAILS) {
            if (this.state.hasSmartIdCard === false) {
                allFieldsComplete = this.doneSelectingDocument("Identity") && allFieldsComplete;
            } else {
                allFieldsComplete = this.doneSelectingDocument("Identity") && this.doneSelectingDocument("IdentityBack") && allFieldsComplete;
            }
        }
        if (this.state.currentTab === PICTURE_DOCUMENT_DETAILS) {
            allFieldsComplete = this.doneSelectingDocument("Picture") && allFieldsComplete;
        }
        if (this.state.currentTab === PERMIT_DOCUMENT_DETAILS) {
            allFieldsComplete = this.doneSelectingDocument("Permit") && allFieldsComplete;
        }

        return allFieldsComplete;
    }

    toggleHasSmartIdCard() {
        this.setState({
            hasSmartIdCard: !this.state.hasSmartIdCard
        });
    }

    addDocumentToRequiredDocumentList(documentType) {

        let documentInList = false;

        for (let i = 0; i < this.state.requiredDocuments.length; i++) {
            if (this.state.requiredDocuments[i] === documentType) {
                documentInList = true;
            }
        }

        if (documentInList === false) {
            this.state.requiredDocuments.push(documentType)
        }
    }

    render() {
        if (this.state.loading) {
            return <SFXLoadingComponent
                message={this.state.loadingMessage}
            />
        }

        return <Fragment>

            {this.props.isMobile ? this.renderContent("mobile") : this.renderContent("browser")}

        </Fragment>

    }
    
    renderContent(className) {

        const allowedBrowsers = ["Safari", "Chrome", "Edge", "Samsung", "Opera", "UCBrowser"];
        const userAgent = navigator.userAgent;

        const isOnMobile = isMobile || isTablet;
        const isMobileBrowserAllowed = allowedBrowsers.some(browser =>
            userAgent.includes(browser)
        );

        const userSession = getUser();
        const organisationId = userSession.user.organisationId;
        const block3OrgId = process.env.REACT_APP_ORGANISATIONS_CAN_TRANSACT_IDS;
        const isDesktopAllowed =!isOnMobile && organisationId == block3OrgId;

        // Final decision: allow only if it's either (mobile & browser allowed) OR (desktop & user is Block 3 org)
        const isBrowserAllowed = (isOnMobile && isMobileBrowserAllowed) || isDesktopAllowed;

        if (!isBrowserAllowed) {
            return <UnsupportedBrowserComponent isOnMobile ={isOnMobile}/>
        }

        return <Fragment>

            <div className={className + "_background_default_register"}>
                <div className={className + " logo_register"}>
                    <Col align={"center"}>
                        {this.props.isMobile ?
                            <img src={"/images/ria-logo.png"} alt=""
                                 width="auto" height="50px"/> :
                            <div style={{marginTop: "10px"}}>
                                <h1 className={"browser_register_main_heading"}>Sign Up</h1>
                            </div>
                        }
                        <br/>
                        <br/>
                    </Col>
                </div>
                
                <div className={className + "_register_detail_fields"}>
                    {this.state.currentTab === CARD_DETAILS && this.renderCardDetails(className)}
                    {this.state.currentTab === CONTACT_DETAILS && this.renderContactDetails(className)}
                    {this.state.currentTab === IDENTITY_DOCUMENT_DETAILS && this.renderIdentityDocumentDetails(className)}
                    {this.state.currentTab === PICTURE_DOCUMENT_DETAILS && this.renderPictureDocumentDetails(className)}
                    {this.state.currentTab === PERMIT_DOCUMENT_DETAILS && this.renderPermitDocumentDetails(className)}
                    {(this.state.currentTab === ID_DETAILS || this.state.currentTab === ID_DETAILS_SA) && this.renderNationalityDetails(className)}
                    {this.state.currentTab === SECONDARY_PERSONAL_DETAILS && this.renderSecondaryPersonalDetails(className)}
                    {this.state.currentTab === PERSONAL_DETAILS && this.renderPersonalDetails(className)}
                    {this.state.currentTab === ADDRESS_DETAILS && this.renderAddressDetails(className)}
                    {this.state.currentTab === SECONDARY_ADDRESS_DETAILS && this.renderSecondaryAddressDetails(className)}
                    {this.state.currentTab === REGISTRATION_SUMMARY && this.renderSummary(className)}
                </div>
            </div>

        </Fragment>

    }

    getTitleFragment(headerText) {
        return !this.props.isMobile
            ? <Fragment><h2 className={"browser_register_sub_heading"}>{headerText}</h2><br/></Fragment>
            : <Fragment/>
            ;
    }

    renderCardDetails(className) {

        return <Fragment>
            {this.getTitleFragment("Card Details")}

            <Fragment>
                <p className={className + "_register_sub_heading text-center"}>Does the customer want a card?</p>
                <br/>
            </Fragment>
            {this.renderDropdown(className, CARD_OPTIONS, "cardRequested", "Select", "credit-card")}

            {this.renderButton(NEXT_BUTTON_TEXT, CONTACT_DETAILS, className, CARD_DETAILS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}

        </Fragment>

    }


    renderContactDetails(className) {
        let additionalInfo = this.state.cardRequested.id === 1 ? "" : "(This field is optional)";
        let newDetailsPage;
        if (this.state.requiredDocuments.includes('Identity')) {
            newDetailsPage = IDENTITY_DOCUMENT_DETAILS;
        } else if (this.state.requiredDocuments.includes('Picture')) {
            newDetailsPage = PICTURE_DOCUMENT_DETAILS;
        } else if (this.state.requiredDocuments.includes('Permit')) {
            newDetailsPage = PERMIT_DOCUMENT_DETAILS;
        } else {
            newDetailsPage = (this.state.idType.name !== SA_ID && this.state.idType.name !== FOREIGN_ID ? ID_DETAILS : ID_DETAILS_SA)
        }
        return <Fragment>
            {this.getTitleFragment("Contact Details")}

            {this.renderInput(className, "Phone Number", "phoneNumber", "phone")}
            {this.renderInput(className, "Email Address", "email", "envelope", additionalInfo)}

            {this.renderButton(NEXT_BUTTON_TEXT, newDetailsPage, className, CONTACT_DETAILS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}

        </Fragment>

    }

    renderIdentityDocumentDetails(className) {
        let hasThirdDocument = this.state.idType.name === FOREIGN_PASSPORT && this.state.cardRequested.name === "Yes";

        let alternativeNextPage = hasThirdDocument ? PERMIT_DOCUMENT_DETAILS : (this.state.idType.name !== SA_ID && this.state.idType.name !== FOREIGN_ID ? ID_DETAILS : ID_DETAILS_SA);
        let nextDetailsPage = this.state.requiredDocuments.includes('Picture') ? PICTURE_DOCUMENT_DETAILS : alternativeNextPage;

        return <Fragment>

            {this.getTitleFragment("Documents")}

            {this.renderDropdown(className, ID_TYPES, "idType", "ID Type", "flag")}

            {
                this.state.idType.name === SA_ID && <Fragment>
                    {this.renderTickBox(className)}
                </Fragment>
            }
            <br/>
            {this.renderDocumentUploadComponent(className, "Identity")}

            {
                this.state.hasSmartIdCard === true && <Fragment>
                    <br/>
                    {this.addDocumentToRequiredDocumentList("IdentityBack")}
                    {this.renderDocumentUploadComponent(className, "IdentityBack")}
                </Fragment>

            }

            {this.renderButton(NEXT_BUTTON_TEXT, nextDetailsPage, className, DOCUMENTS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}
        </Fragment>

    }

    renderPictureDocumentDetails(className) {
        let thirdDocumentTest = this.state.idType.name === FOREIGN_PASSPORT && this.state.cardRequested.name === "Yes";

        return <Fragment>
            {this.getTitleFragment("Documents")}

            {this.renderDocumentUploadComponent(className, "Picture")}

            {this.renderButton(NEXT_BUTTON_TEXT, thirdDocumentTest ? PERMIT_DOCUMENT_DETAILS : (this.state.idType.name !== SA_ID && this.state.idType.name !== FOREIGN_ID ? ID_DETAILS : ID_DETAILS_SA), className, DOCUMENTS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}
        </Fragment>

    }

    renderPermitDocumentDetails(className) {
        let thirdDocumentTest = this.state.idType.name === FOREIGN_PASSPORT && this.state.cardRequested.name === "Yes";
        if (thirdDocumentTest) {
            this.addDocumentToRequiredDocumentList("Permit")
        }

        return <Fragment>
            {this.getTitleFragment("Documents")}

            {this.renderDocumentUploadComponent(className, "Permit")}

            {this.renderButton(NEXT_BUTTON_TEXT, this.state.idType.name !== SA_ID && this.state.idType.name !== FOREIGN_ID ? ID_DETAILS : ID_DETAILS_SA, className, DOCUMENTS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}
        </Fragment>

    }

    renderDocumentUploadComponent(className, documentType) {
        return <S3DocumentUploadComponent
            key={documentType}
            documentType={documentType}
            showButton={false}
            buttonConfig={BUTTON_HEADERS[documentType]}
            className={className}
            fileSelected={this.state.selectedDocuments[documentType] !== undefined}
            onFileSelected={file => {
                if (file !== null) {
                    let docArr = {...this.state.selectedDocuments};
                    docArr[documentType] = file;
                    this.setState({
                        selectedDocuments: docArr
                    })
                }

            }}
        />;
    }

    renderNationalityDetails(className) {

        return <Fragment>
            {this.getTitleFragment("Identity Details")}
            {this.state.currentTab === ID_DETAILS
                ? <Fragment>
                    {this.renderInput(className, "ID Number", "idNumber", "user")}
                    {this.state.cardRequested.name === "Yes" ? this.renderDatePicker(className, "ID Issue Date", "idIssueDate") : null}
                    {this.renderDatePicker(className, "ID Expiry Date", "idExpiryDate")}
                    {this.renderDropdown(className, this.state.countryOptions, "country", "Nationality", "flag")}
                </Fragment>
                : <Fragment>
                    {this.renderInput(className, "ID Number", "idNumber", "user")}
                    {this.state.cardRequested.name === "Yes" ? this.renderDatePicker(className, "ID Issue Date", "idIssueDate") : null}
                    {this.renderDropdown(className, this.state.countryOptions, "country", "Nationality", "flag")}

                </Fragment>
            }

            {this.renderButton(NEXT_BUTTON_TEXT, SECONDARY_PERSONAL_DETAILS, className, this.state.currentTab === ID_DETAILS ? ID_DETAILS_CONFIG : ID_DETAILS_SA_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}
        </Fragment>

    }

    renderSecondaryPersonalDetails(className) {
        let SAIDcheck = this.state.idType.name === SA_ID;
        return <Fragment>
            {this.getTitleFragment("Personal Details")}
            {SAIDcheck ?
                <Fragment>
                    {this.renderReadOnly(className, "Select Gender", "gender", "user", "(Based on ID number provided)")}
                    {this.renderReadOnly(className, "Date of Birth", "DOB", "calendar", "(Based on ID number provided)")}
                </Fragment>
                :
                <Fragment>
                    {this.renderDropdown(className, GENDERS, "gender", "Select Gender", "user")}
                    {this.renderDatePicker(className, "Date of Birth", "DOB")}
                </Fragment>
            }

            {this.renderButton(SAIDcheck ? CONFIRM_BUTTON_TEXT : NEXT_BUTTON_TEXT, PERSONAL_DETAILS, className, SAIDcheck ? [] : SECONDARY_PERSONAL_DETAILS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}

        </Fragment>

    }

    renderPersonalDetails(className) {

        return <Fragment>
            {this.getTitleFragment("Personal Details")}

            {this.state.cardRequested.name === "Yes" ? this.renderDropdown(className, TITLES, "title", "Title", "user") : null}
            {this.renderInput(className, "First Name", "firstName", "user")}
            {this.renderInput(className, "Last Name", "lastName", "user")}
            {this.state.cardRequested.name === "Yes" ? this.renderDropdown(className, ETHNICITY, "ethnicity", "Ethnicity", "user") : null}
            {this.state.cardRequested.name === "Yes" ? this.renderDropdown(className, SOURCE_OF_FUNDS, "sourceOfFunds", "Source of funds", "money") : null}

            {this.renderButton(NEXT_BUTTON_TEXT, this.state.cardRequested.name === "Yes" ? SECONDARY_ADDRESS_DETAILS : ADDRESS_DETAILS, className, PERSONAL_DETAILS_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}

        </Fragment>

    }


    renderSecondaryAddressDetails(className) {

        return <Fragment>
            {this.getTitleFragment("Address Details")}
            <Fragment>
                <p className={className + "_register_sub_heading text-center"}>Does the customer live in a complex?</p>
                <br/>
            </Fragment>
            {this.renderDropdown(className, CARD_OPTIONS, "staysInComplex", "Select", "map-marker")}
            {this.state.staysInComplex.name === "Yes" ? this.renderInput(className, "Unit Number", "unit", "map-marker") : null}
            {this.state.staysInComplex.name === "Yes" ? this.renderInput(className, "Complex/Building Name", "complexName", "map-marker") : null}

            {this.renderButton(NEXT_BUTTON_TEXT, ADDRESS_DETAILS, className, this.state.staysInComplex.name === "Yes" ? SECONDARY_ADDRESS_DETAILS_CONFIG : SECONDARY_ADDRESS_DETAILS_NO_COMPLEX_CONFIG)}
            {this.renderBackButton(BACK_BUTTON_TEXT, className)}
        </Fragment>

    }

    renderAddressDetails(className) {

        return <Fragment>
            {this.getTitleFragment("Address Details")}

            {this.renderInput(className, "Street Number", "streetNumber", "map-marker")}
            {this.renderInput(className, "Street Name", "streetName", "map-marker")}
            {this.renderInput(className, "Suburb/Town", "town", "map-marker")}
            {this.renderInput(className, "City", "city", "map-marker")}
            {this.renderDropdown(className, this.state.provinceOptions, "province", "Province", "map-marker")}
            {this.renderInput(className, "Postal Code", "postalCode", "map-marker")}

            {this.renderFinishButton("SUBMIT", className, ADDRESS_DETAILS_CONFIG)}
            {this.renderBackButton("BACK", className)}
        </Fragment>

    }

    renderSummary(className) {

        return <Fragment>

            {this.getTitleFragment("Registration Complete")}

            <h2 className={className + "_register_sub_heading text-center"}>Thank you!</h2>
            <p className={"text-center"}>This registration is under review - the customer will be notified once the
                registration has been approved</p>
            <br/>
            {this.renderBackButton("DONE", className)}

        </Fragment>

    }

    renderButton(buttonText, detailsPage, className, config) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_register_button"}
                onClick={() => this.showNextDetailsPage(detailsPage)}
                disabled={!this.isNextButtonValid(config)}
            >{buttonText}
            </SFXButtonComponent>
        </div>
    }

    renderBackButton(buttonText, className) {

        return <Fragment>
            <div className={className + "_register_button_div"}>
                <SFXButtonComponent
                    className={"browser_register_back_button"}
                    onClick={() => this.goBack()}
                >{buttonText}
                </SFXButtonComponent>
            </div>
        </Fragment>
    }

    renderFinishButton(buttonText, className, config) {

        return <div className={className + "_register_button_div"}>
            <SFXButtonComponent
                className={className + "_register_button"}
                onClick={() => this.setState({
                    submitButtonClicked: true,
                    loading: true,
                    loadingMessage: "Submitting Registration"
                }, this.handleUpload)}
                disabled={!this.isNextButtonValid(config)}
            >{buttonText}
            </SFXButtonComponent>
        </div>

    }

    renderInput(className, text, field, icon, additionalInfo) {

        return <Row className={className + "_input_row_register"}>
            <div className={"fa fa-" + icon + " " + className + "_user_icon_register"}/>
            <div className={className + "_input_div_register"}>
                <Input className={className + "_input_register"} value={this.state[field]} placeholder={text}
                       id={field}
                       onChange={(event) => this.handleChange(event, field)}
                       onBlur={() => this.hasBeenTouched(field)}
                />
                {this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)}
                {additionalInfo && this.renderAdditionalInfo(className, additionalInfo)}
            </div>
        </Row>

    }

    renderReadOnly(className, text, field, icon, additionalInfo) {
        let fieldValue = this.state[field].id === undefined ? this.state[field] : this.state[field].name;

        return <Row className={className + "_input_row_register"}>
            <div className={"fa fa-" + icon + " " + className + "_user_icon_register"}/>
            <div className={className + "_input_div_register"}>
                <Input className={className + "_input_register"} value={fieldValue} placeholder={text}
                       id={field}
                       readOnly={true}
                />
                {this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)}
                {additionalInfo && this.renderAdditionalInfo(className, additionalInfo)}
            </div>
        </Row>

    }

    renderDatePicker(className, text, field, additionalInfo) {

        let dateType = "";
        if (field === "DOB") {
            dateType = "PAST";
        } else if (field === "idExpiryDate") {
            dateType = "ID_EXPIRY";
        } else if (field === "idIssueDate") {
            dateType = "PAST";
        }

        return <Row className={className + "_input_row_register"}>
            <div className={"fa fa-calendar " + className + "_user_icon_register"}/>
            <div className={className + "_input_div_register"}>
                <DatePickerComponent
                    inputStyle={className + "_input_register"}
                    onChange={(value) => {
                        this.handleDateChange(field, value)
                    }}
                    isMobile={this.props.isMobile}
                    firstTouch={() => this.hasBeenTouched(field)}
                    value={this.state[field]}
                    placeholder={text}
                    type={dateType}
                />
                {this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)}
                {additionalInfo && this.renderAdditionalInfo(className, additionalInfo)}
            </div>
        </Row>

    }

    renderDropdown(className, dropdownOptions, field, text, icon, additionalInfo) {

        return <Row className={className + "_input_row_register"}>
            <div className={"fa fa-" + icon + " " + className + "_user_icon_register"}/>
            <div className={className + "_input_div_register"}>
                <DropdownComponent
                    className={className + "_input_register"}
                    value={this.state[field].id || ""}
                    options={dropdownOptions}
                    placeholder={text}
                    onChange={(selectedOption) => {
                        this.dropdownChange(selectedOption, field)
                    }}
                    onBlur={() => this.hasBeenTouched(field)}
                />
                {this.state.touchedFields[field] && this.state.inValidFields[field] && this.renderErrorMessage(className, field)}
                {additionalInfo && this.renderAdditionalInfo(className, additionalInfo)}
            </div>
        </Row>
    }

    renderTickBox(className) {

        return <Fragment>

            <Row className={className + "_row"}>
                <Col>
                    <div style={{display: "flex", flex: "4"}}>
                        <div style={{width: "15%", marginBottom: "30px", textAlign: "right"}}>
                            <Input style={{transform: "scale(2.5)", flex: "1"}}
                                   onChange={() => this.toggleHasSmartIdCard()}
                                   type="checkbox"
                                   checked={this.state.hasSmartIdCard}
                            />
                        </div>
                        <div style={{textAlign: "left", flex: "3", margin: "auto", paddingLeft: "10px"}}>Do you have a
                            smart id card?
                        </div>
                    </div>
                </Col>
            </Row>

        </Fragment>
    }

    renderErrorMessage(className, field) {
        return <h6 className={className + "_error_message_register"}>
            {this.state.inValidFields[field]}
        </h6>;
    }

    renderAdditionalInfo(className, text) {
        return <h6 className={className + "_optional_message_register"}>
            {text}
        </h6>;
    }
}

export default withRouter(Register);
